import { API_BASE } from '../config';
import { jwtDecode } from 'jwt-decode';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './pages.css';

const UserLogin = () => {
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [error, setError] = useState('');

    const [showEducationNotice, setShowEducationNotice] = useState(true);
    const [hideToday, setHideToday] = useState(false);
    const [educationNotice, setEducationNotice] = useState(null);

    const navigate = useNavigate();

    // 오늘 날짜를 YYYY-MM-DD 형태로 반환
    const getToday = () => {
        const now = new Date();

        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        // 기존 토큰 제거
        localStorage.removeItem('token');

        try {
            // 이름과 비밀번호를 로컬 저장소에 저장
            localStorage.setItem('name', name);
            localStorage.setItem('phone', phone);

            const res = await fetch(`${API_BASE}/api/login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, phone }),
            });

            const data = await res.json();

            if (res.ok) {
                localStorage.setItem('token', data.token);

                const decoded = jwtDecode(data.token);

                if (decoded.role === 'admin') {
                    navigate('/dashboard');
                } else {
                    navigate('/survey');
                }
            } else {
                setError(data.error || '로그인에 실패했습니다.');
            }
        } catch (err) {
            setError('서버 오류가 발생했습니다.');
        }
    };

    useEffect(() => {
        const controller = new AbortController();
        fetch(`${API_BASE}/api/login-notice`, { signal: controller.signal, cache: 'no-store' })
            .then(async res => {
                if (!res.ok) throw new Error('공지 조회 실패');
                const notice = await res.json();
                if (!controller.signal.aborted) setEducationNotice(notice);
            })
            .catch(() => { /* 공지 조회 실패 시에도 로그인은 계속 사용할 수 있습니다. */ });

        // 저장된 기존 로그인 정보 불러오기
        const savedName = localStorage.getItem('name');
        const savedPhone = localStorage.getItem('phone');

        if (savedName) {
            setName(savedName);
        }

        if (savedPhone) {
            setPhone(savedPhone);
        }

        // 오늘 하루 그만 보기 확인
        const savedDate = localStorage.getItem('educationNoticeHideDate');
        const today = getToday();

        if (savedDate === today) {
            setShowEducationNotice(false);
        }

        // 로그인 배경 설정
        document.body.classList.add('login-page-bg');

        return () => {
            controller.abort();
            document.body.classList.remove('login-page-bg');
        };
    }, []);

    return (
            <>
                <form className="login-form" onSubmit={handleLogin}>
            
                    <h1>공공 모바일 UI/UX 국민평가</h1>
            
                    <div className="education-info">
                        <div
                            className="education-button-group"
                            style={{
                                display: 'flex',
                                gap: '12px',
                                flexWrap: 'wrap'
                            }}
                        >
                            <a
                                href="https://youtu.be/zLfGGxHttqY"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="education-button"
                            >
                                사전교육 영상 시청
                            </a>
            
                            <a
                                href="/국민평가단_사전교육자료.pdf"
                                download
                                className="education-button"
                            >
                                교육 자료 다운로드
                            </a>
                        </div>
                    </div>
                <h3>로그인</h3>

                <div>
                    <label>이름:</label>
                    <input
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        className="input-beauty"
                    />
                </div>

                <div>
                    <label>비밀번호:</label>
                    <input
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                        className="input-beauty"
                    />
                </div>

                <button className="login-button" type="submit">
                    로그인
                </button>

                <a
                    className="kakao-openchat-button"
                    href="https://open.kakao.com/o/g99ahbOi"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    카카오톡 오픈채팅방 참여하기
                </a>

                {error && <p style={{ color: 'red' }}>{error}</p>}
            </form>


            {/* 평가단 교육 안내 */}
            {showEducationNotice && educationNotice && (
                <div className="education-notice">

                    <button
                        type="button"
                        className="education-notice-close"
                        onClick={() => {
                            if (hideToday) {
                                localStorage.setItem(
                                    'educationNoticeHideDate',
                                    getToday()
                                );
                            }

                            setShowEducationNotice(false);
                        }}
                        aria-label="교육 안내 닫기"
                    >
                        ×
                    </button>

                    <h3>{educationNotice.title}</h3>
                    <div className="education-notice-body">{educationNotice.body}</div>
                    
                    <label className="education-notice-today">
                        <input
                            type="checkbox"
                            checked={hideToday}
                            onChange={(e) => setHideToday(e.target.checked)}
                        />
                        오늘 하루 그만 보기
                    </label>

                </div>
            )}
        </>
    );
};

export default UserLogin;
